import { ElementLoader } from "./ElementLoader";
import { Datasets, getConfig, getSettings, } from "@hydrosoft/chart";
import { Utils } from "@hydrosoft/map-api";
import { ElementTitleLoader } from "./ElementTitleLoader";
import { ElementSubTitleLoader } from "./ElementSubTitleLoader";
import { ElementDatasetLoader } from "./ElementDatasetLoader";
import { ElementAxisLoader } from "./ElementAxisLoader";
export class ElementChartLoader extends ElementLoader {
    getSettings() {
        return getSettings(Utils.getAttributes(this._element.attribs, []));
    }
    getConfig() {
        const prefix = "hv-chart";
        const datasets = new Datasets();
        let titleLoader;
        let subTitleLoader;
        let xAxisLoader;
        let yAxisLoader;
        this._element.children.forEach((child) => {
            if (child.tagName === `${prefix}-title`) {
                titleLoader = new ElementTitleLoader(child);
            }
            else if (child.tagName === `${prefix}-subtitle`) {
                subTitleLoader = new ElementSubTitleLoader(child);
            }
            else if (child.tagName === `${prefix}-dataset`) {
                datasets.addDataset(new ElementDatasetLoader(child));
            }
            else if (child.tagName === `${prefix}-x-axis`) {
                xAxisLoader = new ElementAxisLoader(child);
            }
            else if (child.tagName === `${prefix}-y-axis`) {
                yAxisLoader = new ElementAxisLoader(child);
            }
        });
        return getConfig(this.getSettings(), datasets, titleLoader, subTitleLoader, xAxisLoader, yAxisLoader);
    }
}
//# sourceMappingURL=ElementChartLoader.js.map